import dayjs from 'dayjs';

export const dateTimeFormat: Intl.DateTimeFormatOptions = {
  month: 'long',
  day: 'numeric',
  year: 'numeric',
};

export const getDaysAgo = (date: Date, verb: string): string => {
  const now = dayjs();
  const dateTime = date.toLocaleDateString('en-US', dateTimeFormat);
  const daysAgo = dayjs(now).diff(date, 'day');
  let expiryString: string = dateTime;
  if (daysAgo === 1) {
    expiryString += ` (${verb} 1 day ago)`;
  } else if (daysAgo > 1) {
    expiryString += ` (${verb} ${daysAgo} days ago)`;
  } else {
    expiryString += ` (${verb} <1 day ago)`;
  }
  return expiryString;
};
